import React from 'react';
import moment from 'moment';
import { Button, Modal } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
// Types
import { GetMyInvoices_getMyInvoices_entities } from 'api/brandSubscriptions/types/GetMyInvoices';
// Helpers
import { formatPrice } from 'components/common/ManageMerch/helpers';
import {
  mapInvoiceStatusToLabel,
  mapInvoiceTypeToLabel,
} from 'helpers/invoice';
// Constants
import { onlyDateTimeFormat } from 'constants/global';
// Styles
import styles from './BillingDetailsModal.module.scss';

type BillingDetailsModalProps = {
  open: boolean;
  invoice: GetMyInvoices_getMyInvoices_entities | null;
  onClose: () => void;
  onDownloadInvoice: () => void;
};

const BillingDetailsModal = ({
  open,
  invoice,
  onClose,
  onDownloadInvoice,
}: BillingDetailsModalProps): JSX.Element => {
  if (!invoice) return <></>;

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      title="Billing Details"
      width={600}
      footer={null}
      className={styles.modal}
    >
      <div className={styles.modalContent}>
        <div className={styles.invoiceHeader}>
          <div className={styles.invoiceTitle}>
            <h3>Monthly Invoice</h3>
            <span className={styles.statusBadge}>
              {mapInvoiceStatusToLabel(invoice.status)}
            </span>
          </div>
          {invoice.paidAt && (
            <p className={styles.invoiceDate}>
              Invoice date {moment(invoice.paidAt).format(onlyDateTimeFormat)}
            </p>
          )}
        </div>

        <div className={styles.divider} />

        <div className={styles.billingAttributes}>
          <div className={styles.attribute}>
            <span className={styles.label}>Due date</span>
            <span className={styles.value}>
              {invoice.paidAt
                ? moment(invoice.paidAt).format(onlyDateTimeFormat)
                : 'N/A'}
            </span>
          </div>
          <div className={styles.attribute}>
            <span className={styles.label}>Status</span>
            <span className={styles.value}>
              {mapInvoiceStatusToLabel(invoice.status)}
            </span>
          </div>
          <div className={styles.attribute}>
            <span className={styles.label}>Billing Type</span>
            <span className={styles.value}>
              {mapInvoiceTypeToLabel(invoice.type)}
            </span>
          </div>
        </div>

        <div className={styles.divider} />

        <div className={styles.description}>
          <h3>Description</h3>
          <div className={styles.descriptionRow}>
            <span>Subscription Plan</span>
            <span>{mapInvoiceTypeToLabel(invoice.type)} Plan</span>
          </div>
        </div>

        <div className={styles.divider} />

        <div className={styles.total}>
          <h3>Total</h3>
          <span className={styles.totalAmount}>
            {formatPrice(invoice.total)}
          </span>
        </div>

        <Button
          onClick={onDownloadInvoice}
          className={styles.downloadInvoiceButton}
          disabled={!invoice.invoicePdfUrl}
          type="primary"
          icon={<DownloadOutlined />}
        >
          Download Invoice
        </Button>
      </div>
    </Modal>
  );
};

export default BillingDetailsModal;
